import React, { FunctionComponent } from 'react';
import { TableRow, TableCell } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { textPlaceholder } from 'Iaso/constants/uiConstants';

const useStyles = makeStyles(theme => ({
    leftCell: {
        borderRight: `1px solid ${theme.palette.lightGray.border}`,
        fontWeight: 'bold',
    },
}));

type RowProps = {
    field: { label: string; value: any };
    placeholder?: string;
};

export const WidgetPaperRow: FunctionComponent<RowProps> = ({
    field,
    placeholder = textPlaceholder,
}) => {
    const { label, value } = field;
    const classes = useStyles();
    return (
        <TableRow>
            <TableCell className={classes.leftCell}>{label}</TableCell>
            <TableCell>{value || placeholder}</TableCell>
        </TableRow>
    );
};
